import { useState } from 'react';

const faqs = [
  {
    question: '何人まで利用できますか？',
    answer:
      '1卓あたり最大6名までご利用いただけます。複数卓のご予約も可能ですので、人数に合わせてご利用ください。',
  },
  {
    question: '1卓だけ、または複数卓で利用できますか？',
    answer:
      'どちらも可能です。1卓のみのご利用はもちろん、複数卓をまとめてご予約いただくこともできます。',
  },
  {
    question: '当日予約はできますか？',
    answer:
      '空きがあれば当日予約も可能です。24時間営業のため、空き状況に応じていつでもご予約・ご利用いただけます。',
  },
  {
    question: 'ディーラーはいますか？',
    answer:
      'ディーラーの常駐・派遣は行っておりません。ポーカーテーブル、チップ、トランプ、自動シャッフル機をご用意していますので、お客様同士でプレイしていただく形となります。',
  },
  {
    question: '喫煙はできますか？',
    answer:
      '加熱式タバコはご利用いただけます。紙巻きタバコはご利用いただけません。',
  },
  {
    question: '食べ物や飲み物の持ち込みは可能ですか？',
    answer:
      '可能です。ゴミは入口のエレベーター横にある指定ゴミ箱へお捨てください。',
  },
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems((current) =>
      current.includes(index)
        ? current.filter((item) => item !== index)
        : [...current, index]
    );
  };

  return (
    <section
      id="faq"
      className="py-20 md:py-28 px-4"
      style={{
        background:
          'linear-gradient(180deg, #071208 0%, #0a1a0c 50%, #071208 100%)',
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-[#d4af37] text-xs md:text-sm tracking-[0.3em] mb-3">
            FAQ
          </p>

          <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
            よくある質問
          </h2>

          <p className="text-white/60 text-sm md:text-base leading-relaxed">
            ご予約・ご利用前によくいただく質問をまとめています。
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openItems.includes(index);

            return (
              <div
                key={faq.question}
                className="border border-white/10 rounded-xl overflow-hidden"
                style={{
                  background: 'rgba(255,255,255,0.03)',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleItem(index)}
                  className="
                    w-full
                    flex
                    items-center
                    justify-between
                    gap-4
                    px-5
                    md:px-6
                    py-5
                    text-left
                    cursor-pointer
                  "
                  aria-expanded={isOpen}
                >
                  <div className="flex items-start gap-3">
                    <span className="text-[#d4af37] font-bold text-lg leading-none mt-0.5">
                      Q.
                    </span>

                    <span className="text-white font-medium text-sm md:text-base leading-relaxed">
                      {faq.question}
                    </span>
                  </div>

                  <span
                    className="
                      text-[#d4af37]
                      text-2xl
                      leading-none
                      flex-shrink-0
                      transition-transform
                      duration-300
                    "
                    style={{
                      transform: isOpen
                        ? 'rotate(45deg)'
                        : 'rotate(0deg)',
                    }}
                  >
                    +
                  </span>
                </button>

                <div
                  className="grid transition-all duration-300"
                  style={{
                    gridTemplateRows: isOpen ? '1fr' : '0fr',
                  }}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 md:px-6 pb-5 md:pb-6">
                      <div className="flex items-start gap-3 border-t border-white/10 pt-4">
                        <span className="text-[#d4af37] font-bold text-lg leading-none mt-0.5">
                          A.
                        </span>

                        <p className="text-white/70 text-sm md:text-base leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}